import { useMemo } from 'react';
import useFetchUserProfile from 'hooks/useFetchUserProfile';

export const useMOrgId = (): string | null => {
  const { data: userProfile } = useFetchUserProfile();

  return useMemo(() => {
    const individualMOrgId = userProfile?.morgAccesses?.[0]?.orgId;
    if (individualMOrgId) return individualMOrgId;
    for (const team of userProfile?.teamAccesses ?? []) {
      const teamMOrgId = team.morgAccesses?.[0]?.orgId;
      if (teamMOrgId) return teamMOrgId;
    }
    return null;
  }, [userProfile?.morgAccesses, userProfile?.teamAccesses]);
};
